import {combineReducers} from 'redux';
import ConfigSetting from './ConfigSetting/reducer'
import UserSetting from './UserSetting/reducer'

export default combineReducers({
    ConfigSetting,
    UserSetting
});